<template>
  <div
    class="fill-height">
    <v-layout wrap>
      <v-dialog v-model="dialog.warning"
          width="350">
          <v-card 
            class="border-radius pa-2">
            <v-card-text>
              <v-img 
                width="125"
                height="125"
                alt="kominfoklaten" 
                :src="require('@/assets/icon/info_warning.png')"
                class="ma-auto my-6">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      size="20"
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>

              <div
                class="body-1 text-center line-text-second">
                <div>
                  Realisasi keuangan (SP2D) yang diinputkan
                
                  belum sesuai dengan data SP2D (BPKPAD) <span v-if="this.$store.state.user.role === 'opd' ? (this.$store.state.user.unit_id === '26' || this.$store.state.user.unit_id === '22' || this.$store.state.user.unit_id === '6' || this.$store.state.user.unit_id === '4' || this.$store.state.user.unit_type === 'Puskesmas') ? true : false : (this.filter.unit_id === '26' || this.filter.unit_id === '22' || this.filter.unit_id === '4' || this.filter.unit_id === '6' || this.filter.unit_type === 'Puskesmas')">dan SP2B</span>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      <v-flex>
        <section>
          <v-row
            class="px-4 pr-1">
            <v-col 
              cols="12">
              <v-row>
                <v-col 
                  cols="12">
                  <v-card
                    class="border-radius"
                    color="#FFFFFF"
                    style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                    <v-card-text
                      class="d-flex align-center">
                      <v-avatar
                        tile
                        size="60">
                        <v-img 
                          alt="amanata" 
                          :src="require('@/assets/icon/statistik.png')"
                          class="ma-auto">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                color="white">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-avatar>

                      <div
                        class="ml-4 mb-1">
                        <div
                          class="title black--text"
                          style="font-weight: 600;">
                          Data Statistik
                        </div>

                        <div
                          class="body-2">
                          Periode Tahun {{ filter.year }} Bulan {{ filter.month_text}}
                        </div>
                      </div>

                      <v-spacer />

                      <div
                        class="d-flex align-center">
                        <div v-if="user.role === 'admin'">
                          <!-- <div class="body-2 mb-2">
                            Pilih Filter
                          </div> -->

                          <!-- <v-autocomplete
                            filled
                            rounded
                            dense

                            :color="set_color"
                            placeholder="Pilih Filter"

                            :items="type"
                            :item-color="set_color"

                            hide-details

                            clearable
                            @click:clear="filter.type = ''"

                            v-model="filter.type"
                            required
                            style="border-radius: 10px; width: 180px;">
                          </v-autocomplete> -->
                        </div>
                        <div v-if="user.role === 'admin'">
                          <div>

                            <v-autocomplete
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Pilih Filter"

                              :items="category"
                              :item-color="set_color"
                              hide-details
                              v-on:change="filter.unit_id = ''; filter.asistensi = ''; filter.type = '';"


                              clearable
                              @click:clear="filter.category = ''"

                              v-model="filter.category"
                              required
                              class="mx-1"
                              style="border-radius: 10px; width: 200px;">
                            </v-autocomplete>
                          </div>
                        </div>
                        <div v-if="user.role === 'admin'">

                          <div v-if="filter.category === 'Gabungan'">
                            <v-autocomplete
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Pilih Filter Gabungan"

                              :items="type"
                              :item-color="set_color"
                              hide-details

                              clearable
                              @click:clear="filter.type = ''"

                              v-model="filter.type"
                              required
                              class="mx-1"
                              style="border-radius: 10px;">
                            </v-autocomplete>
                          </div>
                        </div>
                        <div v-if="user.role === 'admin'">

                          <div v-if="filter.type === 'Asisten'">
                            <v-autocomplete
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Contoh. Asisten Administrasi Umum"

                              :items="asistensi"
                              :item-color="set_color"
                              hide-details

                              clearable
                              @click:clear="filter.asistensi = ''"

                              v-model="filter.asistensi"
                              required
                              class="mx-1"
                              style="border-radius: 10px;">
                            </v-autocomplete>
                          </div>
                        </div>
                        <div v-if="user.role === 'admin'">

                          <div v-if="filter.category === 'OPD'">
                            <v-autocomplete
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Contoh. Bagian Administrasi Pembangunan"

                              :items="unit"
                              item-text="title"
                              item-value="id"
                              :item-color="set_color"
                              hide-details

                              clearable
                              @click:clear="filter.unit_id = ''"

                              v-model="filter.unit_id"
                              class="mx-1"
                              required
                              style="border-radius: 10px;">
                            </v-autocomplete>
                          </div>
                        </div>
                        <div v-if="user.role === 'admin'">

                          <div v-if="filter.type === 'Kecamatan'">

                            <v-autocomplete
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Contoh. Kecamatan Klaten tengah"

                              :items="filter_data.kecamatan"
                              item-text="name"
                              item-value="id"
                              :item-color="set_color"

                              hide-details

                              clearable
                              @click:clear="filter.kecamatan_id = ''"

                              v-model="filter.kecamatan_id"
                              required
                              class="mx-1"
                              style="border-radius: 10px;">
                            </v-autocomplete>
                          </div>
                        </div>

                        <v-select
                          filled
                          rounded
                          dense
                          hide-details
                          :color="set_color"
                          placeholder="Pengecualian"

                          :items="[
                            { text: 'Dengan Pengecualian', value: '1' },
                            { text: 'Tanpa Pengecualian', value: '0' }
                          ]"
                          item-text="text"
                          item-value="value"
                          :item-color="set_color"

                          v-model="filter.is_pengecualian"
                          style="border-radius: 10px; width: 250px;">
                        </v-select>

                        <v-select
                          filled
                          rounded
                          dense

                          :color="set_color"
                          placeholder="Pilih Bulan"

                          hide-details
                          class="mx-1"

                          :items="bulan"
                          :item-color="set_color"

                          v-model="filter.month"
                          style="border-radius: 10px; width: 180px;">
                        </v-select>


                        <v-select
                          filled
                          rounded
                          dense

                          :color="set_color"
                          placeholder="Pilih Tahun"

                          hide-details

                          :items="years"
                          :item-color="set_color"

                          v-model="filter.year"
                          style="border-radius: 10px; width: 120px;">
                        </v-select>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <v-row 
                justify="center">
                <v-col cols="12" md="3">
                  <v-card
                    class="border-radius"
                    color="#FFFFFF"
                    height="100%"
                    style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                    <v-skeleton-loader
                      class="ma-auto"
                      :loading="process.load"
                      type="image">
                      <v-card-text>
                        <div
                          class="d-flex align-start">
                          <div>
                            <div 
                              class="body-1 black--text"
                              style="font-weight: 600; margin-bottom: 3px;">
                              Pagu Anggaran
                            </div>

                            <div
                              class="body-2"
                              style="opacity: 70%;">
                              Bulan <strong>{{ filter.month_text}}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>

                          <v-spacer />

                          <div>
                            <v-img 
                              width="60"
                              height="60"
                              alt="amanata" 
                              :src="require('@/assets/icon/budget.png')"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    color="white">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </div>
                        </div>
                      </v-card-text>

                      <v-card-text
                        class="pt-1">
                        <div
                          class="mb-4">
                          <div>
                            Murni
                          </div>

                          <div
                            class="text-h5 black--text"
                            style="font-weight: 500;">
                            {{ detail.pagu_anggaran | price }}
                          </div>
                        </div>

                        <div>
                          <div>
                            Perubahan
                          </div>

                          <div
                            class="text-h5 black--text"
                            style="font-weight: 500;">
                            <!-- {{ detailPerubahan.pagu_anggaran_perubahan | price }} -->
                            <span v-if="new Date(filter.year, filter.month - 1, 1) < new Date(new Date(this.dpa.perubahan_date).getFullYear(), new Date(this.dpa.perubahan_date).getMonth(), 1)">
                              0
                            </span>
                            <span v-else>
                              {{ detailPerubahan.pagu_anggaran_perubahan | price }}
                            </span>
                          </div>
                        </div>
                      </v-card-text>
                    </v-skeleton-loader>
                  </v-card>
                </v-col>

                <v-col cols="12" md="3" class="pl-0">
                  <v-card
                    class="border-radius"
                    color="#FFFFFF"
                    height="100%"
                    style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                    <v-skeleton-loader
                      class="ma-auto"
                      :loading="process.load"
                      type="image">
                      <v-card-text>
                        <div
                          class="d-flex align-start">
                          <div>
                            <div 
                              class="body-1 black--text"
                              style="font-weight: 600; margin-bottom: 3px;">
                              Anggaran Kas 
                            </div>

                            <div
                              class="body-2"
                              style="opacity: 70%;">
                              Bulan <strong>{{ filter.month_text}}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>

                          <v-spacer />

                          <div>
                            <v-img 
                              width="60"
                              height="60"
                              alt="amanata" 
                              :src="require('@/assets/icon/percent.png')"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    color="white">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </div>
                        </div>
                      </v-card-text>

                      <v-card-text
                        class="pt-1">
                        <div
                          class="mb-4">
                          <div>
                            Murni
                          </div>
                          
                          <div
                            class="text-h5 black--text"
                            style="font-weight: 500;">
                            <span v-if="new Date(filter.year, filter.month - 1, 1) < new Date(new Date(this.dpa.perubahan_date).getFullYear(), new Date(this.dpa.perubahan_date).getMonth(), 1)">
                              {{ detail.target_keuangan | price }}
                            </span>
                            <span v-else>
                              0
                            </span>
                          </div>
                        </div>

                        <div>
                          <div>
                            Perubahan
                          </div>

                          <div
                            class="text-h5 black--text"
                            style="font-weight: 500;">
                            <span v-if="new Date(filter.year, filter.month - 1, 1) < new Date(new Date(this.dpa.perubahan_date).getFullYear(), new Date(this.dpa.perubahan_date).getMonth(), 1)">
                              0
                            </span>
                            <span v-else>
                              {{ detailPerubahan.target_keuangan | price }}
                            </span>
                          </div>
                        </div>
                      </v-card-text>
                    </v-skeleton-loader>
                  </v-card>
                </v-col>

                <v-col 
                  cols="12" 
                  md="6">
                  <v-card
                    class="border-radius"
                    color="#FFFFFF"
                    style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                    <v-skeleton-loader
                      class="ma-auto"
                      :loading="process.load"
                      type="image">
                      <v-card-text>
                        <div
                          class="d-flex align-start">
                          <div>
                            <div 
                              class="body-1 black--text"
                              style="font-weight: 600; margin-bottom: 3px;">
                              Perkembangan Fisik 
                            </div>

                            <div
                              class="body-2"
                              style="opacity: 70%;">
                              Bulan <strong>{{ filter.month_text}}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>

                          <v-spacer />

                          <div>
                            <v-img 
                              width="60"
                              height="60"
                              alt="amanata" 
                              :src="require('@/assets/icon/dash_kegiatan.png')"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    color="white">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </div>
                        </div>
                      </v-card-text>

                      <v-card-text
                        class="py-0">
                        <v-row>
                          <v-col>
                            <div style="font-size: 17px; font-weight: 600;" class="mb-3">
                              Target
                            </div>

                            <div>
                              <div
                                class="mb-4">
                                <div>
                                  Murni
                                </div>
                                
                                <div
                                  class="text-h5 black--text"
                                  style="font-weight: 500;">
                                  {{ new Date(filter.year, filter.month - 1, 1) < new Date(new Date(this.dpa.perubahan_date).getFullYear(), new Date(this.dpa.perubahan_date).getMonth(), 1) ? detail.target_fisik === null ? 0 : detail.target_fisik : 0 }}
                                </div>
                              </div>
      
                              <div>
                                <div>
                                  Perubahan
                                </div>
                                <div
                                  class="text-h5 black--text"
                                  style="font-weight: 500;">
                                  {{ new Date(filter.year, filter.month - 1, 1) < new Date(new Date(this.dpa.perubahan_date).getFullYear(), new Date(this.dpa.perubahan_date).getMonth(), 1) ? 0 : detailPerubahan.target_fisik === null ? 0 : detailPerubahan.target_fisik}}
                                </div>
                              </div>

                            </div>
                          </v-col>

                          <v-col>
                            <div style="font-size: 17px; font-weight: 600;" class="mb-3">
                              Realisasi
                            </div>

                            <div>
                              <div
                                class="mb-4">
                                <div>
                                  Murni
                                </div>
                                
                                <div
                                  class="text-h5 black--text"
                                  style="font-weight: 500;">
                                  {{ new Date(filter.year, filter.month - 1, 1) < new Date(new Date(this.dpa.perubahan_date).getFullYear(), new Date(this.dpa.perubahan_date).getMonth(), 1) ? detail.realisasi_fisik === null ? 0 : detail.realisasi_fisik : 0 }}
                                </div>
                              </div>
      
                              <div>
                                <div>
                                  Perubahan
                                </div>
                                <div
                                  class="text-h5 black--text"
                                  style="font-weight: 500;">
                                  {{ new Date(filter.year, filter.month - 1, 1) < new Date(new Date(this.dpa.perubahan_date).getFullYear(), new Date(this.dpa.perubahan_date).getMonth(), 1) ? 0 : detailPerubahan.realisasi_fisik === null ? 0 : detailPerubahan.realisasi_fisik }}
                                </div>
                              </div>

                            </div>
                          </v-col>

                          <v-col>
                            <div style="font-size: 17px; font-weight: 600;" class="mb-3">
                              Deviasi
                            </div>

                            <div>
                              <div
                                class="mb-4">
                                <div>
                                  Murni
                                </div>
                                
                                <div
                                  class="text-h5 black--text"
                                  style="font-weight: 500;">
                                  {{ new Date(filter.year, filter.month - 1, 1) < new Date(new Date(this.dpa.perubahan_date).getFullYear(), new Date(this.dpa.perubahan_date).getMonth(), 1) ? detail.deviasi_fisik === null ? 0 : detail.deviasi_fisik : 0 }}
                                </div>
                              </div>
      
                              <div>
                                <div>
                                  Perubahan
                                </div>
                                <div
                                  class="text-h5 black--text"
                                  style="font-weight: 500;">
                                  {{ new Date(filter.year, filter.month - 1, 1) < new Date(new Date(this.dpa.perubahan_date).getFullYear(), new Date(this.dpa.perubahan_date).getMonth(), 1) ? 0 : detailPerubahan.deviasi_fisik === null ? 0 : detailPerubahan.deviasi_fisik }}
                                </div>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-skeleton-loader>
                  </v-card>
                </v-col>
              </v-row>

              <v-row>
                <v-col 
                  cols="12" 
                  :md="6">
                  <v-card
                    class="border-radius"
                    color="#FFFFFF"
                    height="100%"
                    style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                    <v-card-text class="pb-0">
                      <div
                          class="d-flex align-start">
                          <div>
                            <div 
                              class="body-1 black--text"
                              style="font-weight: 600; margin-bottom: 3px;">
                              Realisasi Keuangan
                            </div>

                            <div
                              class="body-2"
                              style="opacity: 70%;">
                              Bulan <strong>{{ filter.month_text}}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>

                          <v-spacer />

                          <div>
                            <v-img 
                              width="60"
                              height="60"
                              alt="amanata" 
                              :src="require('@/assets/icon/comparison.png')"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    color="white">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </div>
                        </div>
                    </v-card-text>
                    <v-skeleton-loader
                      class="ma-auto"
                      :loading="process.load"
                      type="article, list-item-three-line, article, list-item-three-line">


                      <!-- <v-divider class="mx-3 my-3"></v-divider> -->
                      <v-card-text>
                        <table style="width: 100%;">
                          <tr>
                            <td class="pl-2 py-1 pr-5" style="border: 1px solid #ededed; font-weight: 600;">
                              Nama
                            </td>
                            <td class="pl-2 py-1 pr-5" style="border: 1px solid #ededed; font-weight: 600;">
                              Nominal 
                            </td>
                            <!-- <td class="pl-2 py-1 pr-5" style="border: 1px solid #ededed; font-weight: 600;">
                              Nominal (Perubahan)
                            </td> -->
                          </tr>
                          <tr v-if="!process.load && this.$store.state.user.role === 'opd' ? true : this.filter.unit_id !== '' && this.filter.unit_id !== null ? true : false">
                            <td class="pl-2 py-1 pr-5" style="border: 1px solid #ededed; font-weight: 500;">
                              Data Keuangan/SP2D (BPKPAD)
                            </td>
                            <td class="pa-2 body-1 black--text" style="border: 1px solid #ededed; font-weight: 500;" v-if="new Date(filter.year, filter.month - 1, 1) < new Date(new Date(this.dpa.perubahan_date).getFullYear(), new Date(this.dpa.perubahan_date).getMonth(), 1)">
                              {{ ((detail.sp2d_bulan*1))| price }}
                            </td>
                            <td class="pa-2 body-1 black--text" style="border: 1px solid #ededed; font-weight: 500;" v-else>
                              {{ ((detailPerubahan.sp2d_bulan*1))| price }}
                            </td>
                          </tr>
                          <tr v-if="!process.load && this.$store.state.user.role === 'opd' ? true : this.filter.unit_id !== '' && this.filter.unit_id !== null ? true : false">
                            <td class="pl-2 py-1 pr-5" style="border: 1px solid #ededed; font-weight: 500;">
                              Data Keuangan/SP2B
                            </td>
                            <td class="pa-2 body-1 black--text" style="border: 1px solid #ededed; font-weight: 500;" v-if="new Date(filter.year, filter.month - 1, 1) < new Date(new Date(this.dpa.perubahan_date).getFullYear(), new Date(this.dpa.perubahan_date).getMonth(), 1)">
                              {{ ((detail.sp2b_bulan*1))| price }}
                            </td>
                            <td class="pa-2 body-1 black--text" style="border: 1px solid #ededed; font-weight: 500;" v-else>
                              {{ ((detailPerubahan.sp2b_bulan*1))| price }}
                            </td>
                          </tr>
                          <tr v-if="!process.load && this.$store.state.user.role === 'opd' ? true : this.filter.unit_id !== '' && this.filter.unit_id !== null ? true : false">
                            <td class="pl-2 py-1 pr-5" style="border: 1px solid #ededed; font-weight: 600; width: 300px;">
                              Total SP2B & SP2D 
                            </td>
                            <td class="pa-2 body-1 font-weight-bold  black--text" style="border: 1px solid #ededed; font-weight: 500;" v-if="new Date(filter.year, filter.month - 1, 1) < new Date(new Date(this.dpa.perubahan_date).getFullYear(), new Date(this.dpa.perubahan_date).getMonth(), 1)">
                              {{ ((detail.sp2b_bulan*1)+(detail.sp2d_bulan*1))| price }}
                            </td>
                            <td class="pa-2 body-1 font-weight-bold  black--text" style="border: 1px solid #ededed; font-weight: 500;" v-else>
                              {{ ((detailPerubahan.sp2b_bulan*1)+(detailPerubahan.sp2d_bulan*1))| price }}
                            </td>
                          </tr>
                          <tr>
                            <td class="pl-2 py-1 pr-5" style="border: 1px solid #ededed; font-weight: 600;">
                              Realisasi Keuangan (OPD)
                            </td>
                            <td class="pa-2 font-weight-bold body-1 black--text" style="border: 1px solid #ededed;" v-if="new Date(filter.year, filter.month - 1, 1) < new Date(new Date(this.dpa.perubahan_date).getFullYear(), new Date(this.dpa.perubahan_date).getMonth(), 1)">
                              {{ detail.realisasi_keuangan === null ? 0 : detail.realisasi_keuangan | price }}
                            </td>
                            <td class="pa-2 font-weight-bold body-1 black--text" style="border: 1px solid #ededed;" v-else>
                              {{ detailPerubahan.realisasi_keuangan === null ? 0 : detailPerubahan.realisasi_keuangan | price }}
                            </td>
                          </tr>
                          <tr :style="((detail.realisasi_keuangan*1)-((detail.sp2b_bulan*1)+(detail.sp2d_bulan*1))) === 0 ? '' : 'background: #FFCDD2;'" v-if="!process.load && this.$store.state.user.role === 'opd' ? true : this.filter.unit_id !== '' && this.filter.unit_id !== null ? true : false">
                            <td class="pl-2 py-1 pr-5" style="border: 1px solid #ededed; font-weight: 600;">
                              Selisih
                            </td>
                            <td class="pa-2 font-weight-bold body-1 black--text" style="border: 1px solid #ededed;" v-if="new Date(filter.year, filter.month - 1, 1) < new Date(new Date(this.dpa.perubahan_date).getFullYear(), new Date(this.dpa.perubahan_date).getMonth(), 1)">
                              {{( (detail.realisasi_keuangan*1)-((detail.sp2b_bulan*1)+(detail.sp2d_bulan*1)))| price }}
                            </td>
                            <td class="pa-2 font-weight-bold body-1 black--text" style="border: 1px solid #ededed;" v-else>
                              {{( (detailPerubahan.realisasi_keuangan*1)-((detailPerubahan.sp2b_bulan*1)+(detailPerubahan.sp2d_bulan*1)))| price }}
                            </td>
                          </tr>
                        </table>
                      </v-card-text>

                      <!-- <v-divider class="mx-3"></v-divider>
                      <v-card-text>
                        <div
                          class="d-flex align-start">
                          <div style="width: calc(100% / 3)">
                            <div 
                              class="body-1 black--text"
                              style="font-weight: 600; margin-bottom: 3px;">
                              Realisasi Keuangan/SP2D (OPD)
                            </div>
      
                            <div
                              class="body-2"
                              style="opacity: 70%;">
                              Bulan <strong>{{ filter.month_text}}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>
                          
      
                          <v-spacer />
                          <div v-if="this.$store.state.user.role === 'opd' ? true : this.filter.unit_id !== '' && this.filter.unit_id !== null ? true : false" style="width: calc(100% / 3)">
                            <div 
                              class="body-1 black--text"
                              style="font-weight: 600; margin-bottom: 3px;">
                              Data Keuangan/SP2D (BPKPAD)
                            </div>
      
                            <div
                              class="body-2"
                              style="opacity: 70%;">
                              Bulan <strong>{{ filter.month_text}}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>

                          <v-spacer />
                          <div v-if="this.$store.state.user.role === 'opd' ? true : this.filter.unit_id !== '' && this.filter.unit_id !== null ? true : false" style="width: calc(100% / 3)">
                            <div 
                              class="body-1 black--text"
                              style="font-weight: 600; margin-bottom: 3px;">
                              Data Keuangan/SP2B
                            </div>
      
                            <div
                              class="body-2"
                              style="opacity: 70%;">
                              Bulan <strong>{{ filter.month_text}}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>
                        </div>
                      </v-card-text>
                      <v-card-text
                        class="pt-1">
                        <div
                          class="d-flex align-start">
                          <div style="width: calc(100% / 3)">
                            <div
                              class="mb-4">
                              <div>
                                Murni
                              </div>
                              
                              <div
                                class="text-h5 black--text"
                                style="font-weight: 500;">
                                <span v-if="detail.realisasi_keuangan === null">
                                  0
                                </span>
                                <span v-else>
                                  {{ detail.realisasi_keuangan | price }}
                                </span>
                              </div>
                            </div>
          
                            <div>
                              <div>
                                Perubahan
                              </div>
  
                              <div
                                class="text-h5 black--text"
                                style="font-weight: 500;">
                                0
                              </div>
                            </div>
                          </div>

                          <v-spacer />

                          <div style="width: calc(100% / 3)" v-if="this.$store.state.user.role === 'opd' ? true : this.filter.unit_id !== '' && this.filter.unit_id !== null ? true : false">
                            <div
                              class="mb-4">
                              <div>
                                Nominal
                              </div>
                              
                              <div
                                class="text-h5 black--text"
                                style="font-weight: 500;">
                                <span v-if="detail.sp2d_bulan === null">
                                  0
                                </span>
                                <span v-else>
                                  {{ detail.sp2d_bulan | price }}
                                </span>
                              </div>
                            </div>
                          </div>

                          <v-spacer />

                          <div style="width: calc(100% / 3)" v-if="this.$store.state.user.role === 'opd' ? true : this.filter.unit_id !== '' && this.filter.unit_id !== null ? true : false">
                            <div
                              class="mb-4">
                              <div>
                                Nominal
                              </div>
                              
                              <div
                                class="text-h5 black--text"
                                style="font-weight: 500;">
                                <span v-if="detail.sp2b_bulan === null">
                                  0
                                </span>
                                <span v-else>
                                  {{ detail.sp2b_bulan | price }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-card-text> -->
                      <!-- <div>
                        <v-divider class="mx-3"></v-divider>

                      </div> -->
                    </v-skeleton-loader>
                  </v-card>
                </v-col>

                <v-col 
                  cols="12" 
                  :md="3">
                  <v-card
                    class="border-radius"
                    color="#FFFFFF"
                    height="100%"
                    style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                    <v-skeleton-loader
                      class="ma-auto"
                      :loading="process.load"
                      type="article, list-item-three-line">
                      <v-card-text class="pb-0">
                        <div
                          class="d-flex align-start">
                          <div>
                            <div 
                              class="body-1 black--text"
                              style="font-weight: 600; margin-bottom: 3px;">
                              Persentase Realisasi Keuangan Terhadap Pagu Anggaran 
                            </div>

                            <div
                              class="body-2"
                              style="opacity: 70%;">
                              Bulan <strong>{{ filter.month_text}}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>
                        </div>
                      </v-card-text>

                      <v-card-text
                        class="mt-9">
                        <div
                          class="text-h5 black--text"
                          style="font-weight: 500;"
                          v-if="new Date(filter.year, filter.month - 1, 1) < new Date(new Date(this.dpa.perubahan_date).getFullYear(), new Date(this.dpa.perubahan_date).getMonth(), 1)"
                          :style="this.$store.state.user.role === 'opd' ? 'font-size: 70px !important; text-align: center; margin-top: 40px;' : this.filter.unit_id !== '' && this.filter.unit_id !== null ? 'font-size: 70px !important; text-align: center; margin-top: 40px;' : ''">
                          {{ detail.sp2d_pagu_anggaran }}
                          <!-- {{ parseFloat(detail.sp2d_pagu_anggaran*100).toFixed(2) }} -->
                        </div>

                        <div
                          class="text-h5 black--text"
                          style="font-weight: 500;"
                          v-else
                          :style="this.$store.state.user.role === 'opd' ? 'font-size: 70px !important; text-align: center; margin-top: 40px;' : this.filter.unit_id !== '' && this.filter.unit_id !== null ? 'font-size: 70px !important; text-align: center; margin-top: 40px;' : ''">
                          {{ detailPerubahan.sp2d_pagu_anggaran }}
                          <!-- {{ parseFloat(detailPerubahan.sp2d_pagu_anggaran*100).toFixed(2) }} -->
                        </div>
                      </v-card-text>
                    </v-skeleton-loader>
                  </v-card>
                </v-col>
                <v-col 
                  cols="12" 
                  :md="3">
                  <v-card
                    class="border-radius"
                    color="#FFFFFF"
                    height="100%"
                    style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                    <v-skeleton-loader
                      class="ma-auto"
                      :loading="process.load"
                      type="article, list-item-three-line">
                      <v-card-text class="pb-0">
                        <div
                          class="d-flex align-start">
                          <div>
                            <div 
                              class="body-1 black--text"
                              style="font-weight: 600; margin-bottom: 3px;">
                              Persentase Realisasi Keuangan Terhadap Anggaran Kas
                            </div>

                            <div
                              class="body-2"
                              style="opacity: 70%;">
                              Bulan <strong>{{ filter.month_text}}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>
                        </div>
                      </v-card-text>

                      <v-card-text
                        class="mt-9">
                        <div
                          class="text-h5 black--text"
                          v-if="new Date(filter.year, filter.month - 1, 1) < new Date(new Date(this.dpa.perubahan_date).getFullYear(), new Date(this.dpa.perubahan_date).getMonth(), 1)"
                          style="font-weight: 500;"
                          :style="this.$store.state.user.role === 'opd' ? 'font-size: 70px !important; text-align: center; margin-top: 40px;' : this.filter.unit_id !== '' && this.filter.unit_id !== null ? 'font-size: 70px !important; text-align: center; margin-top: 40px;' : ''">
                          <!-- {{ detail.sp2d_anggaran === null ? 0 : parseFloat(detail.sp2d_anggaran*100).toFixed(2) }} -->
                          {{ detail.sp2d_anggaran }}
                        </div>

                        <div
                          class="text-h5 black--text"
                          v-else
                          style="font-weight: 500;"
                          :style="this.$store.state.user.role === 'opd' ? 'font-size: 70px !important; text-align: center; margin-top: 40px;' : this.filter.unit_id !== '' && this.filter.unit_id !== null ? 'font-size: 70px !important; text-align: center; margin-top: 40px;' : ''">
                          <!-- {{ detailPerubahan.sp2d_anggaran === null ? 0 : parseFloat(detailPerubahan.sp2d_anggaran*100).toFixed(2) }} -->
                          {{ detailPerubahan.sp2d_anggaran }}
                        </div>

                      </v-card-text>
                    </v-skeleton-loader>
                  </v-card>
                </v-col>

                <!-- <v-col cols="12" v-if="!process.load && this.$store.state.user.role === 'opd' ? true : this.filter.unit_id !== '' && this.filter.unit_id !== null ? true : false">
                  <v-card
                    class="border-radius"
                    color="#FFFFFF"
                    height="100%"
                    style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                    <v-card-text>
                      <div class="body-2">
                        Perbandingan Realisasi Keuangan/SP2D dengan Total SP2B & SP2D
                      </div>
                      <v-divider class="mx-3 my-3"></v-divider>
                      <table>
                        <tr>
                          <td class="pl-2 py-1 pr-5">
                            Realisasi Keuangan/SP2D
                          </td>
                          <td class="pa-2 font-weight-bold body-1 black--text">
                            : {{ detail.realisasi_keuangan === null ? 0 : detail.realisasi_keuangan | price }}
                          </td>
                        </tr>
                        <tr>
                          <td class="pl-2 py-1 pr-5">
                            Total SP2B & SP2D 
                          </td>
                          <td class="pa-2 font-weight-bold body-1 black--text">
                            : {{ ((detail.sp2b_bulan*1)+(detail.sp2d_bulan*1))| price }}
                          </td>
                        </tr>
                        <tr>
                          <td class="pl-2 py-1 pr-5">
                            Selisih
                          </td>
                          <td class="pa-2 font-weight-bold body-1 black--text">
                            : {{( (detail.realisasi_keuangan*1)-((detail.sp2b_bulan*1)+(detail.sp2d_bulan*1)))| price }}
                          </td>
                        </tr>
                      </table>
                    </v-card-text>
                  </v-card>
                </v-col> -->
              </v-row>


              <v-row 
                justify="center">
                <v-col 
                  cols="12" 
                  md="6">
                  <v-card
                    class="border-radius"
                    color="#FFFFFF"
                    style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                    <v-skeleton-loader
                      class="ma-auto"
                      :loading="process.load"
                      type="image">
                      <v-card-text>
                        <div
                          class="d-flex align-start">
                          <div>
                            <div 
                              class="body-1 black--text"
                              style="font-weight: 600; margin-bottom: 3px;">
                              Pengelompokan Prosentase Pelaksanaan Sub Kegiatan 
                            </div>

                            <div
                              class="body-2"
                              style="opacity: 70%;">
                              Bulan <strong>{{ filter.month_text}}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>

                          <v-spacer />

                          <div>
                            <v-img 
                              width="60"
                              height="60"
                              alt="amanata" 
                              :src="require('@/assets/icon/total_persentase_sp2d_anggaran.png')"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    color="white">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </div>
                        </div>
                      </v-card-text>

                      <v-card-text
                        class="pt-0">
                        <table style="width: 100%;" v-if="Object.keys(list.realisasi).length > 0">
                          <tr>
                            <th style="border: 1px solid #ededed; padding: 8px;">Persentase</th>
                            <th style="border: 1px solid #ededed; padding: 8px;">Jumlah</th>
                          </tr>

                          <tr>
                            <td style="border: 1px solid #ededed; padding: 8px; color: white; background: #ff0000d9">
                              0%
                            </td>
                            <td style="border: 1px solid #ededed; padding: 8px; color: white; background: #ff0000d9; font-weight: bold">
                              {{ list.realisasi.a | number }}
                            </td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid #ededed; padding: 8px; background: orange;">
                              1% - 25%
                            </td>
                            <td style="border: 1px solid #ededed; padding: 8px; background: orange; font-weight: bold">
                              {{ list.realisasi.b | number }}
                            </td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid #ededed; padding: 8px; background: yellow;">
                              26% - 50%
                            </td>
                            <td style="border: 1px solid #ededed; padding: 8px; background: yellow; font-weight: bold">
                              {{ list.realisasi.c | number }}
                            </td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid #ededed; padding: 8px; background: green; color: white;">
                              51% - 75%
                            </td>
                            <td style="border: 1px solid #ededed; padding: 8px; background: green; color: white; font-weight: bold">
                              {{ list.realisasi.d | number }}
                            </td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid #ededed; padding: 8px; color: white; background: blue">
                              76% - 99%
                            </td>
                            <td style="border: 1px solid #ededed; padding: 8px; color: white; background: blue; font-weight: bold">
                              {{ list.realisasi.e | number }}
                            </td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid #ededed; padding: 8px;">
                              100%
                            </td>
                            <td style="border: 1px solid #ededed; padding: 8px; font-weight: bold">
                              {{ list.realisasi.f | number }}
                            </td>
                          </tr>
                        </table>
                      </v-card-text>
                    </v-skeleton-loader>
                  </v-card>
                </v-col>
                
                <v-col 
                  cols="12" 
                  md="6">
                  <v-card
                    class="border-radius"
                    color="#FFFFFF"
                    height="100%"
                    style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                    <v-skeleton-loader
                      class="ma-auto"
                      :loading="process.load"
                      type="image">
                      <v-card-text>
                        <div
                          class="d-flex align-start">
                          <div>
                            <div 
                              class="body-1 black--text"
                              style="font-weight: 600; margin-bottom: 3px;">
                              Pengelompokan Deviasi Fisik Sub Kegiatan 
                            </div>

                            <div
                              class="body-2"
                              style="opacity: 70%;">
                              Bulan <strong>{{ filter.month_text}}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>

                          <v-spacer />

                          <div>
                            <v-img 
                              width="60"
                              height="60"
                              alt="amanata" 
                              :src="require('@/assets/icon/analytics.png')"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    color="white">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </div>
                        </div>
                      </v-card-text>

                      <v-card-text
                        class="pt-0">
                        <table style="width: 100%;" class="border-radius" v-if="Object.keys(list.deviasi).length > 0">
                          <tr>
                            <th style="border: 1px solid #ededed; padding: 8px;">Nilai</th>
                            <th style="border: 1px solid #ededed; padding: 8px;">Jumlah</th>
                          </tr>

                          <tr>
                            <td style="border: 1px solid #ededed; padding: 8px; color: white; background: #ff0000d9">
                              -100 s/d -10
                            </td>
                            <td style="border: 1px solid #ededed; padding: 8px; color: white; background: #ff0000d9; font-weight: bold">
                              {{ list.deviasi.a | number }}
                            </td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid #ededed; padding: 8px; background: orange;">
                              -9.99 s/d -6.00
                            </td>
                            <td style="border: 1px solid #ededed; padding: 8px; background: orange; font-weight: bold">
                              {{ list.deviasi.b | number }}
                            </td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid #ededed; padding: 8px; background: yellow;">
                              -5.99 s/d -3.00
                            </td>
                            <td style="border: 1px solid #ededed; padding: 8px; background: yellow; font-weight: bold">
                              {{ list.deviasi.c | number }}
                            </td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid #ededed; padding: 8px; background: green; color: white;">
                              -2.99 s/d 9.99
                            </td>
                            <td style="border: 1px solid #ededed; padding: 8px; background: green; color: white; font-weight: bold">
                              {{ list.deviasi.d | number }}
                            </td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid #ededed; padding: 8px; color: white; background: blue">
                              Lebih dari 10
                            </td>
                            <td style="border: 1px solid #ededed; padding: 8px; color: white; background: blue; font-weight: bold">
                              {{ list.deviasi.e | number }}
                            </td>
                          </tr>
                        </table>
                      </v-card-text>
                    </v-skeleton-loader>
                  </v-card>
                </v-col>
              </v-row>

              <v-row>
                <v-col 
                  cols="12" 
                  md="12">
                  <v-card
                    class="border-radius mb-4"
                    color="#FFFFFF"
                    style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                    <v-skeleton-loader
                      class="ma-auto"
                      :loading="process.load"
                      type="image">
                      <v-card-text>
                        <div
                          class="d-flex align-center">
                          <div>
                            <div 
                              class="body-1 black--text"
                              style="font-weight: 600; margin-bottom: 3px;">
                              Program, Kegiatan & Sub kegiatan 
                            </div>

                            <div
                              class="body-2"
                              style="opacity: 70%;">
                              Bulan <strong>{{ filter.month_text}}</strong> tahun <strong>{{ filter.year }}</strong>
                            </div>
                          </div>

                          <v-spacer />

                          <div>
                            <v-img 
                              width="60"
                              height="60"
                              alt="amanata" 
                              :src="require('@/assets/icon/pengadaan.png')"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    color="white">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </div>
                        </div>
                      </v-card-text>
                    </v-skeleton-loader>
                  </v-card>

                  <v-row>
                    <v-col>
                      <v-card
                        class="border-radius"
                        color="#FFFFFF"
                        style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                        <v-skeleton-loader
                          class="ma-auto"
                          :loading="process.load"
                          type="image">
                          <v-card-text>
                            <div
                              class="d-flex align-start">
                              <div>
                                <div 
                                  class="body-1 black--text"
                                  style="font-weight: 600; margin-bottom: 3px;">
                                  Program 
                                </div>

                                <div
                                  class="body-2"
                                  style="opacity: 70%;">
                                  Bulan <strong>{{ filter.month_text}}</strong> tahun <strong>{{ filter.year }}</strong>
                                </div>
                              </div>

                              <v-spacer />

                              
                            </div>
                          </v-card-text>

                          <v-card-text
                            class="pt-0">
                            <div
                              class="mb-4">
                              <div>
                                Murni
                              </div>

                              <div
                                class="text-h5 black--text"
                                style="font-weight: 500;">
                                {{ detail.total_program | number }}
                              </div>
                            </div>

                            <div>
                              <div>
                                Perubahan
                              </div>

                              <div
                                class="text-h5 black--text"
                                style="font-weight: 500;">
                                {{ detailPerubahan.total_program | number }}
                              </div>
                            </div>
                          </v-card-text>
                        </v-skeleton-loader>
                      </v-card>
                    </v-col>

                    <v-col>
                      <v-card
                        class="border-radius"
                        color="#FFFFFF"
                        style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                        <v-skeleton-loader
                          class="ma-auto"
                          :loading="process.load"
                          type="image">
                          <v-card-text>
                            <div
                              class="d-flex align-start">
                              <div>
                                <div 
                                  class="body-1 black--text"
                                  style="font-weight: 600; margin-bottom: 3px;">
                                  Kegiatan 
                                </div>

                                <div
                                  class="body-2"
                                  style="opacity: 70%;">
                                  Bulan <strong>{{ filter.month_text}}</strong> tahun <strong>{{ filter.year }}</strong>
                                </div>
                              </div>

                              <v-spacer />
                              
                            </div>
                          </v-card-text>

                          <v-card-text
                            class="pt-0">
                            <div
                              class="mb-4">
                              <div>
                                Murni
                              </div>
                              
                              <div
                                class="text-h5 black--text"
                                style="font-weight: 500;">
                                {{ detail.total_kegiatan | number }}
                              </div>
                            </div>

                            <div>
                              <div>
                                Perubahan
                              </div>
                              <div
                                class="text-h5 black--text"
                                style="font-weight: 500;">
                                {{ detailPerubahan.total_kegiatan | number }}
                              </div>
                            </div>
                          </v-card-text>
                        </v-skeleton-loader>
                      </v-card>
                    </v-col>

                    <v-col>
                      <v-card
                        class="border-radius"
                        color="#FFFFFF"
                        style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;">
                        <v-skeleton-loader
                          class="ma-auto"
                          :loading="process.load"
                          type="image">
                          <v-card-text>
                            <div
                              class="d-flex align-start">
                              <div>
                                <div 
                                  class="body-1 black--text"
                                  style="font-weight: 600; margin-bottom: 3px;">
                                  Sub kegiatan 
                                </div>

                                <div
                                  class="body-2"
                                  style="opacity: 70%;">
                                  Bulan <strong>{{ filter.month_text}}</strong> tahun <strong>{{ filter.year }}</strong>
                                </div>
                              </div>

                              <v-spacer />
                              
                            </div>
                          </v-card-text>

                          <v-card-text
                            class="pt-0">
                            <div
                              class="mb-4">
                              <div>
                                Murni
                              </div>

                              <div
                                class="text-h5 black--text"
                                style="font-weight: 500;">
                                {{ detail.total_sub_kegiatan | number }}
                              </div>
                            </div>

                            <div>
                              <div>
                                Perubahan
                              </div>

                              <div
                                class="text-h5 black--text"
                                style="font-weight: 500;">
                                {{ detailPerubahan.total_sub_kegiatan | number }}
                              </div>
                            </div>
                          </v-card-text>
                        </v-skeleton-loader>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { TokenService } from "@/service/Storage.Service";
import { get, post, put, patch, destroy } from "@/service/Axios";
// import { filter } from "core-js/core/array";
  export default {
    data() {
      return {
        dialog: {
          warning: false
        },
        clock: {
          date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          time: ''
        },
        getMonth: new Date().getMonth(),

        type: ['Asisten', 'Sekda', 'Dinas Pendidikan', 'Kecamatan', 'Dinas Kesehatan', 'Semua Kecamatan', 'Semua Kelurahan', 'Semua Puskesmas'],

        category: ['OPD', 'Gabungan'],

        asistensi: ['Asisten Administrasi Umum', 'Asisten Perekonomian dan Pembangunan', 'Asisten Pemerintahan dan Kesejahteraan Rakyat'],

        filter: {
          tahun_anggaran: new Date().getFullYear(),
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          month_text: new Date().toLocaleString('id', { month: 'long' }),
          unit_id: '',
          unit_title: '',
          unit_type: '',
          asistensi: '',
          kecamatan_id: '',
          kecamatan_title: '',
          type: '',
          category: '',
          is_pengecualian: '1'
        },
        filter_data: {
          unit: [],
          kecamatan: [
            {
              name: 'KECAMATAN KLATEN TENGAH',
              id: '42,326,327,328,330,329,325'
            },
            {
              name: 'KECAMATAN KLATEN UTARA',
              id: '43,334,335'
            },
            {
              name: 'KECAMATAN KLATEN SELATAN',
              id: '41,313'
            },
            {
              name: 'KECAMATAN JATINOM',
              id: '32,179'
            }
          ]
        },
        bulan: [
          {
            text: 'Januari',
            value: 1
          },
          {
            text: 'Februari',
            value: 2
          },
          {
            text: 'Maret',
            value: 3
          },
          {
            text: 'April',
            value: 4
          },
          {
            text: 'Mei',
            value: 5
          },
          {
            text: 'Juni',
            value: 6
          },
          {
            text: 'Juli',
            value: 7
          },
          {
            text: 'Agustus',
            value: 8
          },
          {
            text: 'September',
            value: 9
          },
          {
            text: 'Oktober',
            value: 10
          },
          {
            text: 'November',
            value: 11
          },
          {
            text: 'Desember',
            value: 12
          }
        ],
        unit: [],
        detail: {},
        detailPerubahan: {},

        list: {
          data: [],
          summary: {},
          realisasi: {},
          deviasi: {},

          count: [
            {
              name: 'Total Anggaran',
              total: 0,
              icon: require('@/assets/icon/budget.png'),
              sub: []
            },
            {
              name: 'Realisasi Keuangan',
              total: 0,
              icon: require('@/assets/icon/dash_kegiatan.png'),
              sub: []
            },
            {
              name: 'Deviasi',
              total: 0,
              icon: require('@/assets/icon/percent.png'),
              sub: []
            },
            {
              name: 'Rata-Rata Target Fisik',
              total: 0,
              icon: require('@/assets/icon/average_target_fisik_format.png'),
              sub: []
            },
            {
              name: 'Persentase Anggaran SP2D',
              total: 0,
              icon: require('@/assets/icon/total_persentase_sp2d.png'),
              sub: []
            },
            {
              name: 'Persentase SP2D',
              total: 0,
              icon: require('@/assets/icon/total_persentase_sp2d_anggaran.png'),
              sub: []
            }
          ],

          program: [],

          persentase: {
            name: 'Persentase Pekerjaan',
            icon: require('@/assets/icon/dash_persen.png'),
            pie: {
              series: [44, 55, 13, 43, 22],
              chartOptions: {
                chart: {
                  width: 380,
                  type: 'pie',
                },
                labels: ['Team A', 'Team B', 'Team C', 'Team D', 'Team E'],
                responsive: [{
                  breakpoint: 480,
                  options: {
                    chart: {
                      width: 200
                    },
                    legend: {
                      position: 'bottom'
                    }
                  }
                }]
              }
            }
          },
          dataPerubahan: [],
          realisasiPerubahan: {},
          deviasiPerubahan: {},
        },
        
        process: {
          load: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    watch: {
      'filter.type': function () {
        let t = this
        t.filter.asistensi = ''
        t.filter.unit_id = ''
        t.filter.kecamatan_id = ''
        if (t.filter.type === 'Asisten' || t.filter.type === 'Kacamatan') {
          // t.filter.asistensi = 'Asisten Administrasi Umum'
        } else {
          this.fetch()
        }
      },

      'filter.asistensi': function () {
        let t = this

        t.filter.asistensi === null ? t.filter.asistensi = '' : ''

        // let u = this.filter_data.unit.filter(function(v) {
        //   return t.filter.unit_id == v.id
        // })

        // if (u.length > 0) {
        //   this.filter.unit_title = u[0].title
        // }
        this.fetch()
      },

      'filter.is_pengecualian': function () {
        let t = this

        t.filter.is_pengecualian === null ? t.filter.is_pengecualian = '' : ''

        // let u = this.filter_data.unit.filter(function(v) {
        //   return t.filter.unit_id == v.id
        // })

        // if (u.length > 0) {
        //   this.filter.unit_title = u[0].title
        // }
        this.fetch()
      },

      'filter.unit_id': function () {
        let t = this

        t.filter.unit_id === null ? t.filter.unit_id = '' : ''

        let u = this.filter_data.unit.filter(function(v) {
          return t.filter.unit_id == v.id
        })

        if (u.length > 0) {
          this.filter.unit_title = u[0].title
          this.filter.unit_type = u[0].type
        }
        this.fetch()
      },

      'filter.kecamatan_id': function () {
        let t = this

        t.filter.kecamatan_id === null ? t.filter.kecamatan_id = '' : ''

        let u = this.filter_data.kecamatan.filter(function(v) {
          return t.filter.kecamatan_id == v.id
        })

        if (u.length > 0) {
          this.filter.kecamatan_title = u[0].name
        }
        this.fetch()
      },
      'filter.year': function () {
        this.fetchDpa()
      },
      'filter.month': function () {
        this.filter.month_text = ''
        this.bulan.map((v, i) => {
          if (v.value === this.filter.month) {
            this.filter.month_text = v.text
          }
        })
        this.fetch()
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      user () {
        return this.$store.state.user
      },
      dpa () {
        return this.$store.state.dpa
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+93}, ${g+120}, ${b+12})`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.05)`
      },

      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },

      years () {
        let max = new Date('10-01-2024').getFullYear()+6, min = max - 6, years = []

        this.filter.year = this.$store.state.year

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      },
      months () {
        let numb = new Date().getMonth() + 1
        
        this.filter.month = numb

        this.filter.month_text = new Date().toLocaleString('id', { month: 'long' })

        return [
          {
            text: 'Januari',
            value: 1
          },
          {
            text: 'Februari',
            value: 2
          },
          {
            text: 'Maret',
            value: 3
          },
          {
            text: 'April',
            value: 4
          },
          {
            text: 'Mei',
            value: 5
          },
          {
            text: 'Juni',
            value: 6
          },
          {
            text: 'Juli',
            value: 7
          },
          {
            text: 'Agustus',
            value: 8
          },
          {
            text: 'September',
            value: 9
          },
          {
            text: 'Oktober',
            value: 10
          },
          {
            text: 'November',
            value: 11
          },
          {
            text: 'Desember',
            value: 12
          }
        ]
      }
    },
    mounted () {
      setInterval(this.updateTime, 1000)
      
      this.fetchDpa()
      // this.fetch()

      this.fetchUnit()
    },
    methods: {
      async fetchDpa () {
        let params = {
          tahun:  this.filter.year
        }
        await get('admin/dpa/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {

            TokenService.saveDpa(JSON.stringify(res.results.data[0]))

            this.$store.commit("setDpa", res.results.data[0])
            this.fetch()
            
          }
        })
      },
      async fetchUnit () {
        let params = {
          limit: 100000,
          year: new Date().getFullYear()
        }

        await get('admin/unit/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.unit = res.results.data
          }
        })
      },
      async fetch () {
        this.process.load = true

        let params = {
          // unit_id: this.$store.state.user.role === 'opd' ? this.$store.state.user.unit_id : this.filter.unit_id === '' || this.filter.unit_id === null ? 0 : this.filter.unit_id,
          // asisten: this.filter.asistensi,
          // gabungan: this.filter.type === 'Sekda' ? 'setda' : this.filter.type === 'Kecamatan' ? 'kecamatan' : this.filter.type === 'Dinas Pendidikan' ? 'dinas pendidikan' : this.filter.type === 'Dinas Kesehatan' ? 'dinas kesehatan' : this.filter.type === 'Semua Kecamatan' ? 'semua kecamatan' : this.filter.type === 'Semua Kelurahan' ? 'semua kelurahan' : this.filter.type === 'Semua Puskesmas' ? 'semua puskesmas' : '',
          // gabungan_id: this.filter.type === 'Kecamatan' ? this.filter.kecamatan_id : '',

          // is_pengecualian: this.filter.is_pengecualian,

          // year: this.filter.year,
          // month: this.filter.month,
          // dpa_status: 'murni'


          unit_id: this.$store.state.user.role === 'opd' ? this.$store.state.user.unit_id : this.filter.unit_id === '' || this.filter.unit_id === null ? '' : this.filter.unit_id,
          unit_asisten: this.filter.asistensi,
          gabungan: this.filter.type === 'Sekda' ? 'setda' : this.filter.type === 'Kecamatan' ? 'kecamatan' : this.filter.type === 'Dinas Pendidikan' ? 'dinas pendidikan' : this.filter.type === 'Dinas Kesehatan' ? 'dinas kesehatan' : this.filter.type === 'Semua Kecamatan' ? 'semua kecamatan' : this.filter.type === 'Semua Kelurahan' ? 'semua kelurahan' : this.filter.type === 'Semua Puskesmas' ? 'semua puskesmas' : '',
          gabungan_id: this.filter.type === 'Kecamatan' ? this.filter.kecamatan_id : '',

          tahun_anggaran: this.filter.year,
          is_pengecualian: this.filter.is_pengecualian,

          year: this.filter.year,
          month: this.filter.month,
          dpa_status: 'murni'
        }

        await get('admin/dashboard/data', { params })
        .then(response => {
          let res = response.data
            
          // this.process.load = false

          if (res.status === 200) {
            // console.log(this.dpa)
            
            let data = res.results
            if(new Date() < new Date(this.dpa.perubahan_date) === true) {
              if(this.$store.state.user.role === 'opd' && (((data.sp2d_bulan*1) + (data.sp2b_bulan*1)) !== (data.realisasi_keuangan*1))) {
                this.dialog.warning = true
              }

              if(this.$store.state.user.role === 'admin' && (this.filter.unit_id !== '' && this.filter.unit_id !== null) && (((data.sp2d_bulan*1) + (data.sp2b_bulan*1)) !== (data.realisasi_keuangan*1))) {
                this.dialog.warning = true
              }
            }
            
            this.list.data = data.data
            this.detail = data
            this.fetchRealisasi()
          }
        })
      },

      async fetchRealisasi () {
        this.process.load = true

        let params = {
          // unit_id: this.$store.state.user.role === 'opd' ? this.$store.state.user.unit_id : this.filter.unit_id === '' || this.filter.unit_id === null ? 0 : this.filter.unit_id,
          // asisten: this.filter.asistensi,
          // unit_id: this.$store.state.user.role === 'opd' ? this.$store.state.user.unit_id : this.filter.unit_id === '' || this.filter.unit_id === null ? '' : this.filter.unit_id,
          // asisten: this.filter.asistensi,

          // is_pengecualian: this.filter.is_pengecualian,
          // // unit_asisten: this.filter.asistensi,
          // // unit_id: this.filter.unit_id,
          // // unit_asisten: this.filter.asistensi,
          // gabungan: this.filter.type === 'Sekda' ? 'setda' : this.filter.type === 'Kecamatan' ? 'kecamatan' : this.filter.type === 'Dinas Pendidikan' ? 'dinas pendidikan' : this.filter.type === 'Dinas Kesehatan' ? 'dinas kesehatan' : this.filter.type === 'Semua Kecamatan' ? 'semua kecamatan' : this.filter.type === 'Semua Kelurahan' ? 'semua kelurahan' : this.filter.type === 'Semua Puskesmas' ? 'semua puskesmas' : '',
          // gabungan_id: this.filter.type === 'Kecamatan' ? this.filter.kecamatan_id : '',

          // year: this.filter.year,
          // month: this.filter.month,
          // dpa_status: 'murni'

          unit_id: this.$store.state.user.role === 'opd' ? this.$store.state.user.unit_id : this.filter.unit_id === '' || this.filter.unit_id === null ? '' : this.filter.unit_id,
          unit_asisten: this.filter.asistensi,
          gabungan: this.filter.type === 'Sekda' ? 'setda' : this.filter.type === 'Kecamatan' ? 'kecamatan' : this.filter.type === 'Dinas Pendidikan' ? 'dinas pendidikan' : this.filter.type === 'Dinas Kesehatan' ? 'dinas kesehatan' : this.filter.type === 'Semua Kecamatan' ? 'semua kecamatan' : this.filter.type === 'Semua Kelurahan' ? 'semua kelurahan' : this.filter.type === 'Semua Puskesmas' ? 'semua puskesmas' : '',
          gabungan_id: this.filter.type === 'Kecamatan' ? this.filter.kecamatan_id : '',

          tahun_anggaran: this.filter.year,
          is_pengecualian: this.filter.is_pengecualian,

          year: this.filter.year,
          month: this.filter.month,
          dpa_status: 'murni'
        }

        await get('admin/dashboard/sub_kegiatan_group', { params })
        .then(response => {
          let res = response.data
            
          // this.process.load = false

          if (res.status === 200) {
            
            let data = res.results

            this.list.realisasi = data.realisasi_fisik
            this.list.deviasi = data.deviasi
            this.fetchPerubahan()
            // this.detail = data
          }
        })
      },

      async fetchPerubahan () {
        this.process.load = true

        let params = {
          // unit_id: this.$store.state.user.role === 'opd' ? this.$store.state.user.unit_id : this.filter.unit_id === '' || this.filter.unit_id === null ? '' : this.filter.unit_id,
          // asisten: this.filter.asistensi,
          // // unit_id: this.filter.unit_id,
          // // unit_asisten: this.filter.asistensi,
          // gabungan: this.filter.type === 'Sekda' ? 'setda' : this.filter.type === 'Kecamatan' ? 'kecamatan' : this.filter.type === 'Dinas Pendidikan' ? 'dinas pendidikan' : this.filter.type === 'Dinas Kesehatan' ? 'dinas kesehatan' : this.filter.type === 'Semua Kecamatan' ? 'semua kecamatan' : this.filter.type === 'Semua Kelurahan' ? 'semua kelurahan' : this.filter.type === 'Semua Puskesmas' ? 'semua puskesmas' : '',
          // gabungan_id: this.filter.type === 'Kecamatan' ? this.filter.kecamatan_id : '',

          // is_pengecualian: this.filter.is_pengecualian,

          // year: this.filter.year,
          // month: this.filter.month,
          // dpa_status: 'perubahan'

          unit_id: this.$store.state.user.role === 'opd' ? this.$store.state.user.unit_id : this.filter.unit_id === '' || this.filter.unit_id === null ? '' : this.filter.unit_id,
          unit_asisten: this.filter.asistensi,
          gabungan: this.filter.type === 'Sekda' ? 'setda' : this.filter.type === 'Kecamatan' ? 'kecamatan' : this.filter.type === 'Dinas Pendidikan' ? 'dinas pendidikan' : this.filter.type === 'Dinas Kesehatan' ? 'dinas kesehatan' : this.filter.type === 'Semua Kecamatan' ? 'semua kecamatan' : this.filter.type === 'Semua Kelurahan' ? 'semua kelurahan' : this.filter.type === 'Semua Puskesmas' ? 'semua puskesmas' : '',
          gabungan_id: this.filter.type === 'Kecamatan' ? this.filter.kecamatan_id : '',

          tahun_anggaran: this.filter.year,
          is_pengecualian: this.filter.is_pengecualian,

          year: this.filter.year,
          month: this.filter.month,
          dpa_status: 'perubahan'
        }

        await get('admin/dashboard/data', { params })
        .then(response => {
          let res = response.data
            
          // this.process.load = false

          if (res.status === 200) {
            
            let data = res.results
            if(new Date() < new Date(this.dpa.perubahan_date) === false) {
              if(this.$store.state.user.role === 'opd' && (((data.sp2d_bulan*1) + (data.sp2b_bulan*1)) !== (data.realisasi_keuangan*1))) {
                this.dialog.warning = true
              }
  
              if(this.$store.state.user.role === 'admin' && (this.filter.unit_id !== '' && this.filter.unit_id !== null) && (((data.sp2d_bulan*1) + (data.sp2b_bulan*1)) !== (data.realisasi_keuangan*1))) {
                this.dialog.warning = true
              }
            }
            
            this.list.dataPerubahan = data.data
            this.detailPerubahan = data
            this.fetchRealisasiPerubahan()
          }
        })
      },

      async fetchRealisasiPerubahan () {
        this.process.load = true

        let params = {
          // // unit_id: this.$store.state.user.role === 'opd' ? this.$store.state.user.unit_id : this.filter.unit_id === '' || this.filter.unit_id === null ? 0 : this.filter.unit_id,
          // // asisten: this.filter.asistensi,
          // unit_id: this.$store.state.user.role === 'opd' ? this.$store.state.user.unit_id : this.filter.unit_id === '' || this.filter.unit_id === null ? '' : this.filter.unit_id,
          // asisten: this.filter.asistensi,

          // is_pengecualian: this.filter.is_pengecualian,
          // // unit_asisten: this.filter.asistensi,
          // // unit_id: this.filter.unit_id,
          // // unit_asisten: this.filter.asistensi,
          // gabungan: this.filter.type === 'Sekda' ? 'setda' : this.filter.type === 'Kecamatan' ? 'kecamatan' : this.filter.type === 'Dinas Pendidikan' ? 'dinas pendidikan' : this.filter.type === 'Dinas Kesehatan' ? 'dinas kesehatan' : this.filter.type === 'Semua Kecamatan' ? 'semua kecamatan' : this.filter.type === 'Semua Kelurahan' ? 'semua kelurahan' : this.filter.type === 'Semua Puskesmas' ? 'semua puskesmas' : '',
          // gabungan_id: this.filter.type === 'Kecamatan' ? this.filter.kecamatan_id : '',

          // year: this.filter.year,
          // month: this.filter.month,
          // dpa_status: 'perubahan'



          unit_id: this.$store.state.user.role === 'opd' ? this.$store.state.user.unit_id : this.filter.unit_id === '' || this.filter.unit_id === null ? '' : this.filter.unit_id,
          unit_asisten: this.filter.asistensi,
          gabungan: this.filter.type === 'Sekda' ? 'setda' : this.filter.type === 'Kecamatan' ? 'kecamatan' : this.filter.type === 'Dinas Pendidikan' ? 'dinas pendidikan' : this.filter.type === 'Dinas Kesehatan' ? 'dinas kesehatan' : this.filter.type === 'Semua Kecamatan' ? 'semua kecamatan' : this.filter.type === 'Semua Kelurahan' ? 'semua kelurahan' : this.filter.type === 'Semua Puskesmas' ? 'semua puskesmas' : '',
          gabungan_id: this.filter.type === 'Kecamatan' ? this.filter.kecamatan_id : '',

          tahun_anggaran: this.filter.year,
          is_pengecualian: this.filter.is_pengecualian,

          year: this.filter.year,
          month: this.filter.month,
          dpa_status: 'perubahan'
        }

        await get('admin/dashboard/sub_kegiatan_group', { params })
        .then(response => {
          let res = response.data
            
          this.process.load = false

          if (res.status === 200) {
            
            let data = res.results

            this.list.realisasiPerubahan = data.realisasi_fisik
            this.list.deviasiPerubahan = data.deviasi

            if(new Date(this.filter.year, this.filter.month - 1, 1) < new Date(new Date(this.dpa.perubahan_date).getFullYear(), new Date(this.dpa.perubahan_date).getMonth(), 1) === false) {
              this.list.realisasi = data.realisasi_fisik
              this.list.deviasi = data.deviasi
            }
            // this.detail = data
          }
        })
      },

      updateTime () {
        let cd = new Date()

        this.clock.time = this.zeroPadding(cd.getHours(), 2) + ':' + this.zeroPadding(cd.getMinutes(), 2) + ':' + this.zeroPadding(cd.getSeconds(), 2)
      },
      zeroPadding (num, digit) {
        let zero = ''

        for(let i = 0; i < digit; i++) {
          zero += '0'
        }
        return (zero + num).slice(-digit)
      }
    }
  }
</script>

<style>
  table, th, td {
    /* border: 1px solid #ededed;
    border-collapse: collapse; */
    /* border: thin ridge black; */
    border-spacing: 4px;
  border-collapse: collapse;
  }
  .grafik_loader .v-skeleton-loader {
    min-height: 350px !important;
  }

  .grafik_loader .v-skeleton-loader .v-skeleton-loader__image {
    height: 350px !important;
  }

  .text-center {
    background: white !important;
  }
</style>